<div class="language-switcher">
  <p-dropdown
    [ngModel]="selectedLanguage$ | async"
    [options]="(availableLanguages$ | async) || []"
    (onChange)="switchLanguage($event.value)"
  >
    <ng-template pTemplate="selectedItem">
      <div class="flex align-items-center gap-2" *ngIf="selectedLanguage$ | async">
        <img class="lang-flag" src="../assets/icons/{{ selectedLanguage$ | async }}-flag.svg" />
        <div>{{ getLanguageName(selectedLanguage$ | async) }}</div>
      </div>
    </ng-template>
    <ng-template let-lang pTemplate="item">
      <div class="flex align-items-center gap-2 max-w-4.9rem">
        <img class="lang-flag" src="../assets/icons/{{ lang }}-flag.svg" />
        <div>{{ getLanguageName(lang) }}</div>
      </div>
    </ng-template>
  </p-dropdown>
</div>
